import { render, staticRenderFns } from "./braceletsDetails.vue?vue&type=template&id=0a4214a2&scoped=true&"
import script from "./braceletsDetails.vue?vue&type=script&lang=js&"
export * from "./braceletsDetails.vue?vue&type=script&lang=js&"
import style0 from "./braceletsDetails.vue?vue&type=style&index=0&id=0a4214a2&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0a4214a2",
  null
  
)

export default component.exports